var ColorTheoryRegistry = require('./theory/colorTheoryRegistry');
    /**
    * Factory method. Creates a new ColorList based on the given
    * {@link ColorTheoryStrategy} instance and the given source color. The
    * number of colors returned will vary with the strategy chosen.
    * @param {string|toxi.color.theory.*Strategy} strategy either a string
    * for a strategy, such as "splitComplementary" or an instance of a strategy
    * @param {toxi.color.TColor} c a color to base the strategy off
    * @return {toxi.color.ColorList} new list
    */
    module.exports = function(strategy, c){
        if(typeof strategy == 'string'){
            strategy = ColorTheoryRegistry.getStrategyForName(strategy);
        }
        var list;
        if(strategy !== undefined){
            list = strategy.createListFromColor(c);
        }
        return list;
    };




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/color/createListUsingStrategy.js
// module id = 4494
// module chunks = 13